var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxtThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.833 187.5H37.5V12.5H129.167L170.833 54.1667V187.5Z",
    fill: "#BA68C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.583 58.3333H125V18.75L164.583 58.3333Z",
    fill: "#F3E5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5229 103.007H78.2687V137.498H69.8646V103.007H59.7812V96.0276H88.5188V103.007H88.5229ZM106.327 110.269L111.91 96.0276H121.51L111.769 116.594L121.735 137.498H112.023L106.327 123.003L100.656 137.498H90.9437L100.915 116.59L91.1437 96.0234H100.744L106.327 110.269ZM152.84 103.007H142.585V137.498H134.181V103.007H124.098V96.0276H152.835V103.007H152.84Z",
    fill: "#4A148C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtThumbnail);
export default __webpack_public_path__ + "static/media/txt-thumbnail.d3b1dd02beef1d7ec2812a73568be0d5.svg";
export { ForwardRef as ReactComponent };